export default "__VITE_ASSET__MsqUIQ11__"